import { Interpolation } from '@emotion/react';
import { Icon, pxToRem, Theme } from '@lbcamden/lib-react';
import { ReactNode, Ref } from 'react';

import { BodyContentVC } from '../../common/BodyContent';
import { FooterContent, PageContent, SplashPageRoot } from './SplashPage.styled';

type Props = {
  css?: Interpolation<Theme>;
  className?: string;
  children?: ReactNode;
  footerContent?: ReactNode;
  ref?: Ref<HTMLDivElement>;
};

export const SplashPage = ({ ref, children, footerContent, ...rootProps }: Props) => (
  <SplashPageRoot ref={ref} {...rootProps}>
    <BodyContentVC>
      <Icon icon="logos/home-visits-logo-stacked-black" width={pxToRem(200)} />
      <PageContent>{children}</PageContent>
    </BodyContentVC>
    <FooterContent>{footerContent}</FooterContent>
  </SplashPageRoot>
);
